import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full overflow-y-scroll bg-white rounded-l-lg shadow-xl" }
const _hoisted_2 = { class: "relative flex flex-col h-full" }
const _hoisted_3 = { class: "flex items-center space-x-2 px-6 pt-6 pb-2 shrink-0" }
const _hoisted_4 = { class: "text-sm text-neutral-900" }
const _hoisted_5 = { class: "relative group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-6 z-10 rounded bg-gray-500 p-3 text-white text-xs min-w-[220px] group-hover:block hidden" }, [
  /*#__PURE__*/_createElementVNode("p", null, "This type allows users to choose one from a predefined options."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Tip:"),
    /*#__PURE__*/_createTextVNode(" Use this type to limit/control all the users response. "),
    /*#__PURE__*/_createElementVNode("i", null, "(This type is allowed to have sub-forms.)")
  ])
], -1)
const _hoisted_7 = { class: "px-6 pt-5 pb-6 flex-1 flex flex-col" }
const _hoisted_8 = { class: "flex-1 h-full flex flex-col space-y-5" }
const _hoisted_9 = { class: "mt-6 self-end shrink-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Add Field", -1)

import { ref, onMounted, watch, computed } from "vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import FieldLabelText from "../Components/Inputs/FieldLabelText.vue";
import RequiredSwitch from "../Components/Inputs/RequiredSwitch.vue";
import CheckboxOption from "../Components/Inputs/CheckboxOption.vue";
import DataRadio from "../Components/Inputs/DataRadio.vue";
import {
	TransitionChild,
	TransitionRoot,
} from "@headlessui/vue";
import { InformationCircleIcon, ArrowLeftIcon } from "@heroicons/vue/24/outline";



export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxModal',
  props: {
	show: {
		type: Boolean,
		default: false,
	},
	title: {
		type: String,
		default: '',
	},
},
  setup(__props) {

const props = __props;

const changeMeOptions = [
    { id: '1', label: 'Change', value: 'Change', radioSelected: null},
    { id: '2', label: 'Me', value: 'Me', radioSelected: null},
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: __props.show
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "absolute right-0 inset-y-0 w-full overflow-hidden h-[calc(100vh-148px)]",
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "transform transition ease-in-out duration-300",
            "enter-from": "translate-x-full",
            "enter-to": "translate-x-0",
            leave: "transform transition ease-in-out duration-300",
            "leave-from": "translate-x-0",
            "leave-to": "translate-x-full"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(ArrowLeftIcon), {
                      class: "w-6 h-6 text-neutral-500 hover:text-primary-600 transition cursor-pointer",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                    }),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(__props.title), 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_unref(InformationCircleIcon), { class: "w-5 h-5 text-primary-600 cursor-pointer" }),
                      _hoisted_6
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(FieldLabelText),
                      _createVNode(RequiredSwitch),
                      _createVNode(CheckboxOption, null, {
                        default: _withCtx(() => [
                          _createVNode(DataRadio)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(ButtonComponent, null, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ], 32)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})